module.exports = __webpack_public_path__ + "img/even-amundsen-the_deepwoods.10d118e.jpg";